module.exports = __webpack_public_path__ + "static/media/4.182c0c5a.svg";